import React from 'react';
import { useSelector } from 'react-redux';
import styled from '@emotion/styled';

import { INFO_STATUS_BAR_TRANSLATE } from '../../../config';
import { getCurrencySymbol } from '../../../helpers';
import { useAutoTranslation } from '../../../helpers/useAutoTranslation';

const Wrapper = styled('div')`
  padding: 0;
  font-size: 13px;
  > div {
    position: relative;
    display: flex;
    flex-direction: column;
    padding: 10px 12px;
    border-bottom: 1px solid #ccc;
    cursor: pointer;
    background: #ffffff;
    &:nth-child(even) {
      background: #fafafa;
    }

    .order-top,
    .order-bottom {
      display: flex;
      justify-content: space-between;
    }

    .order-id {
      font-weight: 700;
      color: #323a46;
      font-size: 13px;
      line-height: 16px;
      width: 88px;
      margin-right: 20px;
    }
    .order-name {
      margin-top: 4px;
      font-size: 10px;
      color: #72747b;
      line-height: 12px;
      width: 88px;
      text-align: right;
    }
    .order-status {
      margin-top: 4px;
      font-size: 10px;
      color: #72747b;
      line-height: 1.7;
      width: 88px;
      margin-right: 20px;
      line-height: 12px;
    }
    .order-sum {
      color: #323a46;
      font-weight: 500;
      font-size: 13px;
      width: 88px;
      span {
        white-space: nowrap;
      }
      div {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: flex-end;
      }
    }
    &.active {
      .order-id,
      .order-name,
      .order-status,
      .order-sum {
        color: #7e57c2;
      }
      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 4px;
        height: calc(100% + 1px);
        background-color: #7e57c2;
      }
    }
    &:last-child {
      border: none;
    }
  }
`;

const SkeletonWrapper = styled('div')`
  width: auto;
  height: 507px;
  background-color: #fff;
  .skelet {
    background-color: #f2f5f7;
    border-radius: 0.25rem;
    -webkit-animation: blinking 1s infinite ease-in-out;
    animation: blinking 1s infinite ease-in-out;
    @media (max-width: 731px) {
      margin-top: 5px;
    }
  }

  .title {
    height: 10px;
    width: 90px;
  }

  .subtitle {
    height: 6px;
    width: 70px;
    margin-top: 18px;
  }

  .price {
    width: 40px;
    height: 10px;
  }

  .descr {
    width: 40px;
    height: 6px;
    margin-top: 18px;
  }

  .item {
    border-bottom: 1px solid #f2f5f7;
    display: flex;
    justify-content: space-between;
    padding: 10px 12px;
    height: 57px;
  }
`;

const NearestBlock = (props) => {
  const { isNew, data = [], currentOrder, handleChangeOrder } = props;

  const { checkoutSettings } = useSelector((state) => state.settings);

  const { t } = useAutoTranslation();

  if (!data)
    return (
      <SkeletonWrapper>
        <div className="item">
          <div>
            <div className="title skelet"></div>
            <div className="subtitle skelet"></div>
          </div>
          <div>
            <div className="price skelet"></div>
            <div className="descr skelet"></div>
          </div>
        </div>
        <div className="item">
          <div>
            <div className="title skelet"></div>
            <div className="subtitle skelet"></div>
          </div>
          <div>
            <div className="price skelet"></div>
            <div className="descr skelet"></div>
          </div>
        </div>
        <div className="item">
          <div>
            <div className="title skelet"></div>
            <div className="subtitle skelet"></div>
          </div>
          <div>
            <div className="price skelet"></div>
            <div className="descr skelet"></div>
          </div>
        </div>
        <div className="item">
          <div>
            <div className="title skelet"></div>
            <div className="subtitle skelet"></div>
          </div>
          <div>
            <div className="price skelet"></div>
            <div className="descr skelet"></div>
          </div>
        </div>
        <div className="item">
          <div>
            <div className="title skelet"></div>
            <div className="subtitle skelet"></div>
          </div>
          <div>
            <div className="price skelet"></div>
            <div className="descr skelet"></div>
          </div>
        </div>
        <div className="item">
          <div>
            <div className="title skelet"></div>
            <div className="subtitle skelet"></div>
          </div>
          <div>
            <div className="price skelet"></div>
            <div className="descr skelet"></div>
          </div>
        </div>
        <div className="item">
          <div>
            <div className="title skelet"></div>
            <div className="subtitle skelet"></div>
          </div>
          <div>
            <div className="price skelet"></div>
            <div className="descr skelet"></div>
          </div>
        </div>
        <div className="item">
          <div>
            <div className="title skelet"></div>
            <div className="subtitle skelet"></div>
          </div>
          <div>
            <div className="price skelet"></div>
            <div className="descr skelet"></div>
          </div>
        </div>
        <div className="item">
          <div>
            <div className="title skelet"></div>
            <div className="subtitle skelet"></div>
          </div>
          <div>
            <div className="price skelet"></div>
            <div className="descr skelet"></div>
          </div>
        </div>
      </SkeletonWrapper>
    );

  const currencySymbol = getCurrencySymbol(checkoutSettings.currency);

  return (
    <Wrapper className="card-box">
      {isNew ? (
        <div style={{ height: '59px' }} className="card-title">
          <div>
            <div className="order-id" style={{ marginTop: '9px' }}>
              Новый заказ
            </div>
          </div>
        </div>
      ) : null}
      {data && data !== undefined && data[0] !== 'NOT_FOUND'
        ? data.map((n) => (
            <div
              key={n.id}
              className={`${n.id === currentOrder.id ? 'active' : ''}`}
              onClick={() => handleChangeOrder(n)}
            >
              <div className="order-top">
                <div className="order-id">{n.id}</div>
                <div className="order-sum">
                  <div>
                    {n.paymentMethodCode && n.paymentMethodCode === 'online' ? (
                      <i className="fe-credit-card mr-1" />
                    ) : null}
                    <span>{`${n.totalOrderSum} ${currencySymbol}`}</span>
                  </div>
                </div>
              </div>
              <div className="order-bottom">
                <div className="order-status">{t(INFO_STATUS_BAR_TRANSLATE[n.status])}</div>
                <div className="order-name">{`${n.delivery?.receiver.name || ''} 
            ${n.delivery?.receiver.surname || ''}`}</div>
              </div>
            </div>
          ))
        : null}
    </Wrapper>
  );
};

export default NearestBlock;
